module.exports = __webpack_public_path__ + "img/bg_M.c9ac485e.png";